module.exports = __webpack_public_path__ + "static/media/users_icon_blue.4b2f89f2.png";